export const replaceSpaces = (str: string) => {
  if (typeof str !== 'string') return ''

  return str.replaceAll(' ', '-')
}
